var HistoryCurveConst = /** @class */ (function () {
    function HistoryCurveConst() {
    }
    HistoryCurveConst.defaultCalibrationColor = '#7f939f';
    HistoryCurveConst.defaultCalibrationDigitFont = '12px';
    HistoryCurveConst.defaultFontColor = '#000000';
    HistoryCurveConst.defaultFontFamily = 'sans-serif';
    return HistoryCurveConst;
}());
export { HistoryCurveConst };
